import React from "react";
import {EmailLog} from "../types";

type Props = {
    email: EmailLog;
    onClose: () => void;
};

const downloadEmailDetails = (email: EmailLog) => {
    const safe = (v: unknown) => {
        if (typeof v === "string") {
            return v;
        }
        if (Array.isArray(v)) {
            return v.map((x) => (x == null ? "" : String(x))).filter(Boolean).join(", ");
        }
        return v == null ? "" : String(v);
    };
    const lines = [
        `Data: ${safe(email.timestamp)}`,
        `Tipo: ${safe(email.type)}`,
        `Stato invio mail: ${safe(email.status)}`,
        `Da: ${safe(email.email_from) || "-"}`,
        `A: ${safe(email.email_to) || "-"}`,
        `Oggetto: ${safe(email.subject) || "-"}`,
    ];
    const text = lines.join("\n") + "\n";
    const blob = new Blob([text], {type: "text/plain;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const ts = safe(email.timestamp).replaceAll(":", "-").replaceAll("/", "-").replaceAll(" ", "_");
    a.href = url;
    a.download = `email_${ts || "dettaglio"}.txt`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};

export const EmailModal: React.FC<Props> = ({email, onClose}) => {
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <h3 className="modal-title">Dettaglio Email</h3>

                <div className="modal-grid">
                    <div>
                        <b>Data:</b> {email.timestamp}
                    </div>
                    <div>
                        <b>Tipo:</b> {email.type}
                    </div>
                    <div>
                        <b>Stato invio mail:</b> {email.status}
                    </div>
                    <div>
                        <b>Da:</b> {email.email_from ?? "-"}
                    </div>
                    <div>
                        <b>A:</b>{" "}
                        {Array.isArray(email.email_to) ? email.email_to.join(", ") : email.email_to ?? "-"}
                    </div>
                    <div>
                        <b>Oggetto:</b> {email.subject ?? "-"}
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="link-button" onClick={onClose}>
                        Chiudi
                    </button>
                    <button className="link-button" onClick={() => downloadEmailDetails(email)}>
                        Download TXT
                    </button>
                </div>
            </div>
        </div>
    );
};

